<template>
  <!-- 新增/编辑 -->
  <el-dialog
    :title="showShop ? '选择推荐店铺' : '选择推荐商品'"
    :visible.sync="dialogVisible"
    width="960px"
    @open="open"
    :close-on-click-modal="false"
    :append-to-body="appendToBody"
  >
    <ShopAutocomplete
      ref="shopRef"
      v-if="showShop"
      @handleSelect="handleSelect"
    />
    <SelectGoods ref="selectGoodsRef" @submit="handleSubmit" :shopInfo="shopData" :sourceParentPage="sourceParentPage"/>
  </el-dialog>
</template>

<script>
import ShopAutocomplete from "./shopAutocomplete";
import SelectGoods from "./selectGoods";
import {
  addRecommendGoods,
  updateSurnameRecommendShop,
} from "@/api/recommendationHome";

export default {
  components: {
    ShopAutocomplete,
    SelectGoods,
  },
  props: {
    sourceParentPage:{
      type: String,
      default: "",
    }, 
    type: {
      type: Number,
      default: 1,
    },
    showShop: {
      type: Boolean,
      default: true,
    },
    floor: {
      type: Number,
      default: 0,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    shopInfo:{
      type: Object,
      default: () => {},
    },
    isFloorSkuCover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: "",
      dialogVisible: false,
      tableData: [],
      shopId:"",
      shopName:"",
      shopData: {},
      isFloorSkuCoverFlag: false
    };
  },
  computed: {},
  watch: {
    shopInfo: {
      handler(val) {
        this.shopData = val ? {...val} : {};
      },
      deep: true,
    },
    isFloorSkuCover: {
      handler(val) {
        this.isFloorSkuCoverFlag = val
        console.log('isFloorSkuCover======',val);
      },
      immediate: true,
      deep: true,
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    open() {
      const { showShop } = this;
      this.$nextTick(() => {
        this.$refs.selectGoodsRef.clearData();
        if (showShop) {
          this.$refs.shopRef.params.keyWords = this.shopName ?? "";
          if(this.shopName) {
            this.$refs.shopRef.querySearchAsync();
            this.tableData = [];
            this.$refs.selectGoodsRef.getClassify1();
            this.$refs.selectGoodsRef.searchFrom.shopId = this.shopId ?? ""; 
            this.$refs.selectGoodsRef.onQuery();
          }
        }
        this.$refs.selectGoodsRef.showShop = showShop;
        !showShop && this.$refs.selectGoodsRef.getClassify1();
      });
    },
    handleSelect(row) {
      this.tableData = [];
      this.$refs.selectGoodsRef.getClassify1();
      this.$refs.selectGoodsRef.searchFrom.shopId = row?.id ?? "";
      if(!this.$refs.selectGoodsRef.searchFrom.shopId) {
        this.$refs.selectGoodsRef.clearData();
      }
    },
    handleSubmit(form) {
      console.log('xxxxxxxxxxx====form', form);
      this.dialogVisible = false;
      let params = {
        type: this.type,
        shopGoodsId: this.showShop ? form.skuId : null,
        baseGoodsId: form.goodsId,
        floor: this.type == 3  ? this.floor : 0,
      };
      console.log('this.id', this.id)
      if (this.id) {
        // 商品补位设置中不需要传商品id 其他情况需要
        params.shopGoodsId = this.type == 3 && this.isFloorSkuCoverFlag ? null : params.shopGoodsId;
        this.onEdit({ ...params, id: this.id });
        return;
      }
      this.onAdd(params);
    },

    onEdit(params) {
      updateSurnameRecommendShop(params).then((res) => {
        if (res.code == 0) {
          this.$message.success("编辑成功！");
          this.$emit("refreshList");
        }
      });
    },
    onAdd(params) {
      addRecommendGoods(params).then((res) => {
        if (res.code == 0) {
          this.$message.success("新增成功！");
          this.$emit("refreshList");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-search {
  display: flex;
  justify-content: space-between;
}
</style>
